/* global window, document */

import React from 'react';
import ReactGA from 'react-ga';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';

import './Style.css';
import image from './profile_picture.jpeg';

const NavigationItem = props => (
  <div
    className={`Navigation-item${props.selected ? ' selected' : ''}`}
    onClick={props.onClick}
    role="button"
    tabIndex={props.tabIndex}
  >
    {props.title}
  </div>
);

NavigationItem.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  tabIndex: PropTypes.number.isRequired,
  selected: PropTypes.bool,
};

NavigationItem.defaultProps = {
  selected: false,
};

const Menu = props => (
  <div className="Navigation-menu">
    <NavigationItem
      title="Home"
      onClick={() => { props.onClick('/'); }}
      tabIndex={-2}
      selected={props.pathname === '/'}
    />
    <NavigationItem
      title="Research"
      onClick={() => { props.onClick('/research'); }}
      tabIndex={-1}
      selected={props.pathname === '/research'}
    />
    <NavigationItem
      title="About Me"
      onClick={() => { props.onClick('/about'); }}
      tabIndex={0}
      selected={props.pathname === '/about'}
    />
  </div>
);

Menu.propTypes = {
  onClick: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  pathname: state.routing.locationBeforeTransitions.pathname,
});

const mapDispatchToProps = dispatch => ({
  onClick: (path) => {
    dispatch(push(path));
    window.scrollTo(0, 0);
  },
});

export class Navigation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuVisible: false,
    };

    this.toggleMenu = this.toggleMenu.bind(this);
    this.onCLickMenuItem = this.onCLickMenuItem.bind(this);
  }

  onCLickMenuItem(path) {
    this.toggleMenu();
    this.props.onClick(path);
  }

  toggleMenu() {
    this.setState({
      menuVisible: !this.state.menuVisible,
    });
  }

  render() {
    const menu = (
      <Menu
        onClick={this.onCLickMenuItem}
        pathname={this.props.pathname}
      />
    );
    return (
      <div className="Navigation">
        <div
          className={`Navigation-hamburger-menu${this.state.menuVisible ? ' visible' : ''}`}
          onClick={this.toggleMenu}
          role="button"
          tabIndex={-3}
        >
          <i
            className="fa fa-times"
            aria-hidden="true"
          />
          {menu}
        </div>
        <div className="Navigation-hamburger">
          <i
            className="fa fa-bars"
            aria-hidden="true"
            onClick={this.toggleMenu}
          />
        </div>
        <div className="Navigation-image-and-name">
          <div className={`Navigation-image-holder${this.props.isSmaller ? ' smaller' : ''}`}>
            <img
              src={image}
              className={`${this.props.isSmaller ? 'smaller' : ''}`}
              alt="profile"
            />
          </div>
          <div className="Navigation-name">
            Ece Kural, PhD
          </div>
        </div>
        <div className="Navigation-title">
          PhD in International Relations
        </div>
        <div className="Navigation-title">
          Stockholm Universtiy
        </div>
        <div className="Navigation-social">
          <i
            className="fa fa-linkedin"
            aria-hidden="true"
            onClick={() => {
              ReactGA.outboundLink({ label: 'Nav Linkedin Link' }, () => {});
              window.open('https://www.linkedin.com/in/ece-kural/', '_blank');
            }}
          />
          <i
            className="fa fa-medium"
            aria-hidden="true"
            onClick={() => {
              ReactGA.outboundLink({ label: 'Nav Medium Link' }, () => {});
              window.open('https://medium.com/@EceThinks', '_blank');
            }}
          />
          <i
            className="fa fa-twitter"
            aria-hidden="true"
            onClick={() => {
              ReactGA.outboundLink({ label: 'Nav Twitter Link' }, () => {});
              window.open('https://twitter.com/EceThinks', '_blank');
            }}
          />
        </div>
        <div className="Navigation-normal-menu">
          {menu}
        </div>
      </div>
    );
  }
}

Navigation.propTypes = {
  onClick: PropTypes.func.isRequired,
  pathname: PropTypes.string,
  isSmaller: PropTypes.bool.isRequired,
};

Navigation.defaultProps = {
  pathname: '/',
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Navigation);



// WEBPACK FOOTER //
// ./src/template/navigation/View.js